const XOGalleries = [];
window.addEventListener('DOMContentLoaded',function(){
    const isMobile = window.innerWidth <= 576;
    const selector = isMobile ? ".vw-product-tabs-mobile .ui-accordion-header" : ".vw-product-tabs-desktop .ui-accordion-header";

    function attachEventListeners() {
        const allTabsHeader = document.querySelectorAll(selector);
        if (allTabsHeader.length > 0) {
          for (let i = 0; i < allTabsHeader.length; i++) {
            allTabsHeader[i].addEventListener("click", function() {
              setTimeout(() => {
                initXOGallery();
              }, 300);
              setTimeout(() => {
                  for(let i = 0; i < XOGalleries.length; i++) {
                    XOGalleries[i].forceResize();
                  }
                }, 600);
            });
          }
        }
    }

    setTimeout(attachEventListeners, 500);
});

